<app-navbar class="app-navbar" [class.d-none]="hideHeader"></app-navbar>
<div class="app-content layout-main-container">
    <router-outlet class="d-none"></router-outlet>
</div>
<app-footer *ngIf="!isHideFooter() && !hideFooter" class="app-footer"></app-footer>

<q-guided-tour></q-guided-tour>